import uuid from 'uuid';
import { AnyAction, Dispatch } from 'redux';
import { connect, InferableComponentEnhancerWithProps } from 'react-redux';
import { AppState } from 'acscp/store';
import { getRequestErrorFromState, RequestStateProps } from 'acscp/components/common/helpers/requestStateProps';
import { BaseRequest, RequestClass } from 'acscp/api/requests';
import { FetchRequest, FetchResetStatus } from 'acscp/actions';

export function connectWithRequests<StateProps, DispatchProps, OwnProps>(
    mapStateToProps: (
        state: AppState,
        ownProps: OwnProps,
        getRequestError?: (request: RequestClass<any> | BaseRequest<any>) => RequestStateProps
    ) => StateProps,
    mapDispatchToProps: (dispatch: Dispatch, ownProps: OwnProps) => DispatchProps
): InferableComponentEnhancerWithProps<StateProps & DispatchProps, OwnProps> {
    const id = uuid.v4();
    return connect(
        (state: AppState, ownProps: OwnProps) => mapStateToProps(
            state,
            ownProps,
            (request: RequestClass<any> | BaseRequest<any>) => {
                return getRequestErrorFromState(state, request, id);
            }
        ),
        (dispatch: Dispatch, ownProps: OwnProps) => mapDispatchToProps(<TAction extends AnyAction>(action: TAction) => {
            if (action instanceof FetchRequest || action instanceof FetchResetStatus) {
                action.callerId = id;
            }
            return dispatch(action);
        }, ownProps)
    );
}
